module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_10.56f5d07f.png";